import toast, { Toaster } from "react-hot-toast";
const toastStyles = {
  success: {
    duration: 4000,
    style: {
      background: "#10B981",
      color: "#fff",
      fontWeight: "500",
      borderRadius: "12px",
      boxShadow: "0 10px 25px rgba(16, 185, 129, 0.3)",
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#10B981",
    },
  },
  error: {
    duration: 6000,
    style: {
      background: "#EF4444",
      color: "#fff",
      fontWeight: "500",
      borderRadius: "12px",
      boxShadow: "0 10px 25px rgba(239, 68, 68, 0.3)",
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#EF4444",
    },
  },
  loading: {
    style: {
      background: "#3B82F6",
      color: "#fff",
      fontWeight: "500",
      borderRadius: "12px",
      boxShadow: "0 10px 25px rgba(59, 130, 246, 0.3)",
    },
  },
  custom: {
    duration: 5000,
    style: {
      background: "#F59E0B",
      color: "#fff",
      fontWeight: "500",
      borderRadius: "12px",
      boxShadow: "0 10px 25px rgba(245, 158, 11, 0.3)",
    },
  },
};

// Toast utility functions
export const showToast = {
  success: (message, options = {}) => {
    toast.success(message, {
      ...toastStyles.success,
      ...options,
    });
  },

  error: (message, options = {}) => {
    toast.error(message, {
      ...toastStyles.error,
      ...options,
    });
  },

  loading: (message, options = {}) => {
    return toast.loading(message, {
      ...toastStyles.loading,
      ...options,
    });
  },

  promise: (promise, messages, options = {}) => {
    return toast.promise(
      promise,
      {
        loading: messages.loading || "Loading...",
        success: messages.success || "Success!",
        error: messages.error || "Something went wrong",
      },
      {
        success: toastStyles.success,
        error: toastStyles.error,
        loading: toastStyles.loading,
        ...options,
      }
    );
  },

  custom: (message, icon = "🔔", options = {}) => {
    toast(message, {
      icon: icon,
      ...toastStyles.custom,
      ...options,
    });
  },

  dismiss: (toastId) => {
    toast.dismiss(toastId);
  },

  dismissAll: () => {
    toast.dismiss();
  },
};
